





























import { Vue, Component, Prop } from 'vue-property-decorator'
@Component
export default class Step3 extends Vue {
  @Prop() stepAllForm!: any
  vaildSubmit(cb: Function) {
    // eslint-disable-next-line standard/no-callback-literal
    cb(true)
  }
}
